import Vue from "vue";
import store from "@/store"
import Router from "vue-router";
Vue.use(Router);

const router =new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Inicio",
      component: () => import("@/containers/DefaultContainer"),
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: () => import("@/views/Dashboard")
        },
        {
          path: "tipo-cambio",
          meta: {label: "Tipo Cambio Dolares Cordobas"},
          name: "Tipo de Cambio",
          component: () => import("@/views/catalogos/TipoCambio")
        },
        {
          path: "/catalogos",
          meta: {
            label: "Catalogos de Cuentas"
          },
          name: "Catalogos de Cuentas",
          component: () => import("@/views/catalogos/CatalogoCuentas")
        },
        {
          path: "empresas",
          meta: {label: "Empresas", requiresAuth:true},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/catalogos/empresas/List"),
              meta: {requiresAuth:true},
            },
            {
              path: "areas",
              meta: {label: "Areas",requiresAuth:true},
              name: "Areas",
              component: () => import("@/views/catalogos/empresas/List"),
            },
            {
              path: "crear-empresa",
              meta: {label: "Nueva Empresa",requiresAuth:true},
              name: "Crear Empresa",
              component: () => import("@/views/catalogos/empresas/Form")
            },
            {
              path: ":id",
              meta: {label: "Actualizar Empresa",requiresAuth:true},
              name: "Empresa",
              component: () => import("@/views/catalogos/empresas/Form")
            }
          ]
        },
        {
          path: "centros",
          meta: {label: "Centros",requiresAuth:true},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/catalogos/centro/Centros"),
              meta:{requiresAuth:true}
            },
            {
              path: "centros",
              meta: {label: "Centros",requiresAuth:true},
              name: "Centros",
              component: () => import("@/views/catalogos/centro/Centros")
            },
            {
              path: "crear-centro",
              meta: {label: "Crear Centro",requiresAuth:true},
              name: "Crear Centro",
              component: () => import("@/views/catalogos/centro/CentroForm")
            },
            {
              path: ":id",
              meta: {label: "Actualizar Centro",requiresAuth:true},
              name: "Centro",
              component: () => import("@/views/catalogos/centro/CentroForm")
            }
          ]
        },
        {
          path: "tipos-comprobantes",
          meta: {label: "Tipos de Comprobantes",requiresAuth:true},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              meta:{requiresAuth:true},
              component: () => import("@/views/catalogos/tipocomprobantes/TipoComprobantes")
            },
            {
              path: "tipos-comprobantes",
              meta: {label: "Tipos de Comprobantes",requiresAuth:true},
              name: "tipocomprobantes",
              component: () =>import("@/views/catalogos/tipocomprobantes/TipoComprobantes")
            },
            {
              path: "crear-tipo-comprobante",
              meta: {label: "Crear Tipo de Comprobante",requiresAuth:true},
              name: "Crear Tipo de Comprobante",
              component: () => import("@/views/catalogos/tipocomprobantes/TipoComprobantesForm")},
            {
              path: ":id",
              meta: {label: "Actualizar Tipo de Comprobante"},
              name: "actualizar-tipo-comprobante",
              component: () =>import("@/views/catalogos/tipocomprobantes/TipoComprobantesForm")
            }
          ]
        },
        {
          path: "cuentas-cks",
          meta: {label: "Cuentas para Cheques"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/catalogos/ctascks/cuentas")
            },
            {
              path: "cuentas-cks",
              meta: {
                label: "Cuentas para Cheques"
              },
              name: "cuentascks",
              component: () => import("@/views/catalogos/ctascks/cuentas")
            },
            {
              path: "crear",
              meta: {label: "Cuentas para Cheques"},
              name: "CrearCuentaparaCheque",
              component: () => import("@/views/catalogos/ctascks/cuentasForm")
            },
            {
              path: ":id",
              meta: {label: "Actualizar Cuentas para Cheques"},
              name: "Actualizar Cuentas para Cheques",
              component: () => import("@/views/catalogos/ctascks/cuentasForm")
            }
          ]
        },
        //----Operaciones
        {
          path: "comprobantes-diario",
          meta: {label: "Comprobantes de Diario"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              meta: {label: "Index"},
              name: "comprobantes-diario",
              component: () => import("@/views/operaciones/Diario")
            },
            {
              path: "crear",
              meta: {label: "Crear Comprobante de Diario"},
              name: "Crear Comprobante de Diario",
              component: () => import("@/views/operaciones/DiarioForm")
            },
            {
              path: "actualizar/:id",
              meta: {label: "Actualizar Comprobante de Diario"},
              name: "actualizar_comprobante",
              component: () => import("@/views/operaciones/DiarioForm")
            },
            {
              path: "pdf/:id",
              name: "pdf-comprobante",
              component: () => import("@/views/reportes/PdfComprobanteDiario")
            }
          ]
        },
        {
          path: "cheques-transferencias",
          meta: {label: "Cheques - Transferencias"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              meta: {label: "Index"},
              name: "cheques",
              component: () => import("@/views/operaciones/Diario")
            },
            {
              path: "crear",
              meta: {label: "Nuevo Cheque / Transferencia"},
              name: "crearck",
              component: () => import("@/views/operaciones/DiarioForm")
            },
            {
              path: "elaborar/:id",
              meta: {label: "Elaborar Cheque / Transferencia"},
              name: "elaborar_cheque",
              component: () => import("@/views/operaciones/DiarioForm")
            },
            {
              path: "pdf/:id",
              name: "pdf-ckeque-transferencia",
              meta: {label: "Cheque"},
              component: () => import("@/views/reportes/PdfCheques")
            }

          ]
        },
        {
          path: "comprobantes-automaticos",
          meta: {label: "Comprobantes Automáticos"},
          component: () => import("@/views/operaciones/ComprobantesAutomaticos"),
        },
        {
          path: "cierre-mensual",
          meta: {label: "Cierre Mensual"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/operaciones/Asentar")
            },
            {
              path: "cierre-mensual",
              meta: {
                label: "Cierre Mensual"
              },
              name: "asentar",
              component: () => import("@/views/operaciones/Asentar")
            }
          ]
        },
        {
          path: "conciliacion",
          meta: {label: "Conciliación"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/operaciones/Conciliacion")
            },
          ]
        },
        //----Informes / Reportes
        {
          path: "reportes",
          meta: {label: "Reportes"},
          redirect: {
            path: "/reportes/diario"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/reportes/EstadosFinancieros")
            },
            {
              path: "/reportes/estados-financieros-mensuales",
              component: () => import("@/views/reportes/EstadosFinancierosMensuales")
            },
            {
              path: "/reportes/diario",
              name: "LibroDiario",
              component: () => import("@/views/reportes/LDiario")
            },
            {
              path: "/reportes/aux-diario",
              name: "Auxiliar-Diario",
              component: () => import("@/views/reportes/AuxDiario")
            },
            {
              path: "/reportes/bcomprobacion",
              name: "BalanzaComprobacion",
              component: () => import("@/views/reportes/BComprobacion")
            },
            {
              path: "/reportes/mayor",
              name: "LibroMayor",
              component: () => import("@/views/reportes/LMayor")
            },
            {
              path: "/reportes/estados-financieros",
              name: "Estados-Finacieros",
              component: () => import("@/views/reportes/EstadosFinancieros")
            },
            {
              path: "/reportes/estados-financieros/pdf/:url/:empresa/:anio/:mes/:tipo/:aprobados/:concierre",
              name: "pdf-estados-financieros",
              component: () => import("@/views/reportes/PdfReporteEstadoFinanciero")
            },
            {
              path: "/reportes/comparativa",
              name: "comparativa",
              component: () => import("@/views/reportes/Carteravspaco")
            },
          ]
        },
        //--Profile
        {
          path: "profile",
          meta: {label: "Perfil de Usuario"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/users/Profile")
            }
          ]
        },

        //----Usuarios
        {
          path: "users",
          meta: {label: "Usuarios", requiresAuth:true},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: () => import("@/views/users/Users")
            },
            {
              path: ":id",
              meta: {label: "Detalle de Usuarios",requiresAuth:true},
              name: "User",
              component: () => import("@/views/users/User")
            },
            {
              path: "/register",
              name: "Register",
              component: () => import("@/views/users/Register")
            }
          ]
        },

        //----Config reportes
        {
          path: "reportes",
          meta: {label: "Reportes"},
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/config/reportes-create",
              name: "configreportesform",
              component: () => import("@/views/config/ReportesForm")
            },
            {
              path: "/config/reportes-update/:id",
              meta: {label: "Actualizar Configuración de Reportes"},
              name: "actualizar_conf_reportes",
              component: () => import("@/views/config/ReportesForm")
            }
          ]
        },
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/pages/Login")
    },
    {
      path: "/resetPass",
      name: "resetPass",
      component: () => import("@/views/pages/ResetPass")
    },
    {
      path: "/no-encontrado",
      name: "no-encontrado",
      component: () => import("@/views/pages/Page404")
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: () => import("@/views/pages/Page404")
        },
        {
          path: "403",
          name: "Page403",
          component: () => import("@/components/PageForbidden")
        }
      ]
    },
    {
      path: "*",
      meta: {
        public: true
      },
      redirect: {
        path: "/no-encontrado"
      }
    }
  ],

});

router.beforeEach((to, from, next)=>{
  if(to.matched.some(record =>record.meta.requiresAuth)){

    let getters = store.getters;

    if (getters['authentication/getRol'] ==1)
      next();
    else
      next({name:'Page403'})
  }
  else
    next();

});
export default router;
